export class Action {
    id: string;
    name: string;
    command: string;
    description: string;
    parameters: Array<any>;
    builtIn: boolean;
}
